import { DRAG_DIRECTION_RELATIONSHIP_DEFAULTS, DragDirectionConfig, AngleRange } from '../config/canvasConfig';

/**
 * Computes the angle of a drag vector in degrees, normalised to [0, 360).
 *
 *   0°   = right
 *   90°  = down  (screen y-axis points downward)
 *   180° = left
 *   270° = up
 *
 * Returns 0 when both dx and dy are zero (no movement).
 */
export function computeDragAngleDeg(dx: number, dy: number): number {
  const radians = Math.atan2(dy, dx);
  const degrees = radians * (180 / Math.PI);
  return (degrees + 360) % 360;
}

function isInRanges(angle: number, ranges: AngleRange[]): boolean {
  return ranges.some(({ min, max }) => angle >= min && angle < max);
}

/**
 * Returns the default relationship type suggested by the drag direction.
 *
 * @param angleDeg  Drag angle in degrees, normalised to [0, 360).
 * @param config    Optional override; defaults to DRAG_DIRECTION_RELATIONSHIP_DEFAULTS.
 */
export function inferRelationshipTypeFromAngle(
  angleDeg: number,
  config: DragDirectionConfig = DRAG_DIRECTION_RELATIONSHIP_DEFAULTS,
): string {
  if (isInRanges(angleDeg, config.child))  return 'child';
  if (isInRanges(angleDeg, config.parent)) return 'parent';
  if (isInRanges(angleDeg, config.spouse)) return 'spouse';
  return config.fallback;
}
